import { redisGetHandler } from "../utils/redis";
import { draftQueryParam } from "./draft";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getMainSlider(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getMainSlider",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainPopular(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getMainPopular",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainNumbers(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getMainNumbers",
      reset,
    );
  },
  // Где вызывается: клиент и сервер.
  async getMainAdv(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getMainAdv",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getLastNews(Redis, size, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getLastNews?size=${size}`,
      reset,
    );
  },
  // Где вызывается: клиент и сервер.
  async getTeam(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getTeam",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getVideos(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getVideos",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getQuestions(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getQuestionsNotActive",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getReviews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getReviews",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getCatalogBanners(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getCatalogBanners",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getScripts(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/content/getScripts",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainNews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getMainNews`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainProductsReviews(Redis, reset = false, domain) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getMainProductsReviews?domain=${domain}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainPortfolio(Redis, reset = false, domain) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getMainPortfolio?domain=${domain}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMainReviews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getMainReviews`,
      reset,
    );
  },
  // Где вызывается: клиент и сервер.
  async fetchShopReviews(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getMainReviews`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getAboutContent(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getAboutContent`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getSertContent(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getSertContent`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getPromoVideos(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/content/getPromoVideo`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getManagersInstallCorrection(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/content/getAll?type=managers-install-correction${draftQueryParam(config)}`,
      reset,
    );
  },
});
